import MergedImages from "./MergedImages";
import useImageLoader from "./useImageLoader";
import ImageLoadingStatus from "./ImageLoadingStatus";
import G from './Getters';
import React, { useContext, useMemo } from 'react';
import { useStore } from 'react-redux';
import { fullImageAnnotation } from './MicroscopyCropInsertion';
import { FigureChannelAdjustmentContext } from './Contexts';

function MergedImagesWrapper(props){

  let {
    toDraw,
    imageInfoProp,
    adjustmentProp,
    annotationId,
    width: widthProp,
    height: heightProp,
    crop: cropProp,
    imageUrlMap,
    dbgMsg,
  } = props;


  const store = useStore();
  const state = store.getState();

  const { channels, adjustment: adjustmentC, setAdjustment } = useContext(FigureChannelAdjustmentContext);
  let adjustment = adjustmentProp ?? adjustmentC;

 
  console.log(imageInfoProp,toDraw);

  let imageInfo = useMemo(() => {
    return imageInfoProp || toDraw.map(info => {

    let { imageId, channelId } = info;

    if( imageId ){

      let imageSetId = G.getImageSetIdByImageId(state,imageId)
      let atnId = annotationId || fullImageAnnotation(imageSetId);
      let pixelDims = G.getImagePixelDimensionsByAnnotationId(state,{annotationId:atnId});

      let inlineCrop = { ...G.getCropFromAnnotation(state,atnId) };
      delete inlineCrop.annotationId;
      delete inlineCrop.imageId;
      delete inlineCrop.imageSetId;

      let emptyImageCrop = Object.keys(inlineCrop).length === 0;

      let { adjustments } = G.getImage(state,imageId);
      let url = G.getImageRecordUrl(state,{imageId})
      if (imageUrlMap?.[imageId] != null) {
        url = imageUrlMap[imageId];
      }
      return {
        ...info, 
        adjustments: adjustment ? { adjustments, ...adjustment[channelId] } : adjustments,
        url, 
        inlineCrop,
        pixelDims
      }
    }
  }).filter(x => x);
  },[imageInfoProp,toDraw,adjustment])


  let imageIds = toDraw.map(info => info.imageId).filter(v => v);
  const { statuses, success: loadSuccess } = useImageLoader(imageIds);
  if (!loadSuccess) {
    for (let i = 0; i < statuses.length; i++) {
      let imageId = imageIds[i];
      let status = statuses[i];
      let comp = ImageLoadingStatus({ status, wrapperWidth: widthProp, imageId });
      console.log('$st', status, comp);
      if (comp !== null) {
        return comp;
      }
    }
  }

  if( imageInfo?.length === 0 ){

    return (
      <div style={{fontSize:12}}>No<br/> Channels<br/> Selected</div>
    )
  }

  if( !imageInfo ){
    debugger;
  }

return imageInfo && (<><MergedImages {...{
    ...props,
    imageInfo,
    parentComp:"MERGED_IMAGES_WRAPPER",
  }}/>
  </>)



}


export default React.memo(MergedImagesWrapper);
